import { useEffect } from 'react';

const useEffectOnce = (cb: () => void) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(cb, []);
};

export default useEffectOnce;
